import { Divider, Typography } from "@mui/material";
import React from "react";

interface PageTitleProps {
    text: string
}

const PageTitle: React.FC<PageTitleProps> = ({
    text
}) => {
    return (
        <>
            <Typography
                component="h2"
                variant="h6"
                color="inherit"
                noWrap
                sx={{ flexGrow: 1 }}
            >
                {text}
            </Typography>
            <Divider sx={{
                marginBottom: "1em"
            }}/>
        </>
    );
}

export default PageTitle